export default __webpack_public_path__ + "cb951ec972dd37382ce08af8ac8a7912.ico";